import { useLayoutEffect } from 'react'

export const useLockedBody = () => {
  useLayoutEffect(() => {
    const body = document.body

    const disableScrollClass = 'disable-scroll'

    const originalPaddingRight = document.body.style.padding

    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth

    if (!body.classList.contains(disableScrollClass)) {
      body.classList.add(disableScrollClass)

      body.style.paddingRight = `${scrollBarWidth}px`
    }

    return () => {
      if (body.classList.contains(disableScrollClass)) {
        body.classList.remove(disableScrollClass)

        body.style.paddingRight = originalPaddingRight
      }
    }
  }, [])
}
